/**
 * Created by jerome on 09/10/2018.
 */
import SVGCoord from './SVGCoord'

export default class SVGPointShape {
  constructor (x, y) {
    this.main = new SVGCoord(x, y)
    this.left = null
    this.right = null
    this.isplain = true
  }

  setLeft (x, y) {
    this.isplain = false
    this.left = new SVGCoord(x, y)
  }

  setRight (x, y) {
    this.isplain = false
    this.right = new SVGCoord(x, y)
  }

  isPlain () { return this.isplain }

  getPoint () { return this.main }

  getLeft () { return this.isplain ? this.main : ((this.left === null) ? this.main : this.left) }

  getRight () { return this.isplain ? this.main : ((this.right === null) ? this.main : this.right) }
}
